
import Vue from "vue";
import BGItem from "./BGItem.vue";

export default Vue.extend({
  name: "GameModal",
  components: {
    BGItem,
  },
  props: {
    header: String,
    size: Number,
  },
  computed: {
    innerClass: {
      get(): string {
        switch (this.size) {
          case 1:
            return "game-modal-small";

          case 2:
            return "game-modal-medium";

          case 3:
            return "game-modal-big";

          default:
            return "";
        }
      },
    },
  },
});
